<template>
  <LessonContent :title="lesson.title" :order="lesson.order">

     <form-wizard class="mt-3 lesson-wizard"  color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="<" title="" subtitle="" nextButtonText=">" :finishButtonText="buttonTitle">

      <tab-content title="">
        <LessonTabContent>
              <span class="font-black text-6xl">{{lesson.title | capitalize_1}}</span>

              <div class="lesson-intro-image-wrapper">
               <img class="mx-auto p-4 lesson-intro-image" src="@/assets/images/academy/academy_popup_5.svg"/>
             </div>

        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>

          <p>
           Sometimes your journey won't be easy.
          </p>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p class="mb-4">How do you control yourself?</p>

            <div class="flex justify-center">
              <div class="md:w-1/2">
                  <RealityCheckItem class="mb-4" v-model="lessonData.responsibilities" title="I do not avoid my responsibilities"/>
                  <RealityCheckItem class="mb-4" v-model="lessonData.procrastination" title="I do not procrastinate"/>
              </div>

            </div>

       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
          <p class="text-4xl">
            Do you have a backup plan that will keep you on track?
          </p>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>
           To make it easier for your future self, you need to take action today that will remind you in the future<span class="font-semibold"> why you have started.</span>
          </p>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p class="text-4xl">
           Here are some of the tricks that the community or us can recommend.
          </p>

       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
          <p>
            <span class="font-semibold">Letter</span> - write yourself a letter you can read in the near/far future.
          </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>
            <span class="font-semibold">Sticky notes everywhere</span> – remind yourself of your priorities.
          </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>
            <span class="font-semibold">Bet on yourself</span> – have a friend hold you accountable.
          </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>
            <span class="font-semibold">Self-talk</span> - make a promise to yourself and sort your priorities in life.

          </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="" :beforeChange="saveAndExit">
        <LessonTabContent>
          <p>
            <span class="font-semibold">Journey partner</span> – take a journey with a friend, just invite him into improvee.io and motivate each other.

          </p>

          <div class="flex justify-center mt-4">
            <vs-button icon-pack="feather" icon="icon-users" color="#552ac6" class="mt-3" @click="doCopy" >invite partner</vs-button>
          </div>
       </LessonTabContent>
      </tab-content>

    </form-wizard>
  </LessonContent>

</template>

<script>
import LessonContent from './LessonContent'
import LessonTabContent from './LessonTabContent'
import { FormWizard, TabContent } from 'vue-form-wizard'
import LessonMixin from '../../Generic/LessonMixin'
import RealityCheckItem from './RealityCheckItem'

export default {
  components: {
    LessonContent,
    LessonTabContent,
    TabContent,
    FormWizard,
    RealityCheckItem
  },
  props: ['lesson'],
  mixins: [LessonMixin],
  data () {
    return {
      lessonData: {
        responsibilities: null,
        procrastination: null,
      }
    }
  },
  computed: {
    toCopyMessage () {
      return `https://app.improvee.io/onboarding?channel=referral&inviter=${this.userId}`
    },
  },
  methods: {
    doCopy () {
      this.$copyText(this.toCopyMessage).then(() => {
        this.$store.dispatch('ADDITIONAL_USER_INFO', { inviteFriendCopy: true })

        this.$vs.notify({
          title: 'copied to clipboard 🔗',
          text: 'Together, we are going further! #improvetogether',
          color: '#552ac6',
          iconPack: 'feather',
          time: 10000,
          icon:'icon-users'})
      })
    }
  },
}
</script>
